import { createContext } from 'react';

import {
  AccountPlan,
  AccountPlanResponse,
  EditTarget,
} from '@totem/components/accountPlan/types';

interface Context {
  loading: boolean;
  saving: boolean;
  generating: boolean;
  data: AccountPlanResponse | null;
  onRefresh: () => void;
  savePlan: (plan: AccountPlan) => Promise<boolean>;
  generateNarrative: () => void;
  editTarget: EditTarget | null;
  openEditor: (target: EditTarget) => void;
  closeEditor: () => void;
}

export default createContext<Context>({
  loading: false,
  saving: false,
  generating: false,
  data: null,
  onRefresh: () => {},
  savePlan: () => Promise.resolve(false),
  generateNarrative: () => {},
  editTarget: null,
  openEditor: () => {},
  closeEditor: () => {},
});
